import { cssClass } from "@/shared/utils"
import { skeleton } from "./styles/index.css"

interface SkeletonAvatarProps {
  size?: number
}

export const SkeletonAvatar = ({ size = 144 }: SkeletonAvatarProps) => {
  return (
    <div
      className={cssClass([
        skeleton,
        'rounded-20'
      ])}
      style={{ width: size, height: size }}
    />
  )
}